import { Link, SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const ContactInformationPrivacyStatement = () => {
  const { classes } = useTOCStyles();
  const { t } = useTranslation();

  return (
    <div>
      <SectionHeader title="Contact Information" />
      <ol type="a" start={7}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            Please contact QSM at Tel: 6970 6255 / Email:{' '}
            <Link href={t('helpdesk->>Links.SEAB QSM Email')} withUnderline>
              seab_qsm@seab.gov.sg
            </Link>{' '}
            if you :
          </Typography>

          <ol type="i">
            <li className={classes.paragraph}>
              <Typography variant="body1">
                have any enquires or feedback on our data protection policies and procedures,
              </Typography>
            </li>
            <li className={classes.paragraph}>
              <Typography variant="body1">
                need more information on or access to data which you have provided to us in the
                past.
              </Typography>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default ContactInformationPrivacyStatement;
